import { render, staticRenderFns } from "./TipoAbonoComponent.vue?vue&type=template&id=4f071558&"
import script from "./TipoAbonoComponent.vue?vue&type=script&lang=js&"
export * from "./TipoAbonoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports